<template lang="pug">
  .av-propositional-message
    .feature-item(
      v-for="(proposition, index) in propositions"
      :key="`proposition-${index}`")
      .feature-image-container
        img(
          :src="replaceUrlS3(proposition.image, $config.public)"
          :alt="proposition.title"
          class="feature-image")
      .feature-content
        h3.feature-title {{ proposition.title }}
        p.feature-description {{ proposition.description }}
</template>

<script lang="ts">
import { defineComponent } from "vue"
import "@anyvan-ui/propositional-message/PropositionalMessage.css"
import { extractImageUrl, getInnerText } from "~/scripts/useful-functions"
import { replaceUrlS3 } from "~/utils/imageUrlS3"

interface Proposition {
  image: string
  title: string
  description: string
}

export default defineComponent({
  name: "PropositionMessaging",

  props: {
    block: {
      type: Object,
      required: true
    },
    lazy: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    propositions(): Proposition[] {
      if (!this.block?.innerBlocks?.length) {
        return []
      }

      return this.block.innerBlocks.map((articleBlock: any) => {
        const data = this.extractData(articleBlock)
        
        return {
          image: data.image || '',
          title: data.title || '',
          description: data.description || ''
        }
      })
    }
  },

  methods: {
    replaceUrlS3,
    extractData(block: any) {
      const data = { image: '', title: '', description: '' }
      this.traverse(block, data)
      
      return data
    },

    traverse(block: any, data: any) {
      if (block.type === 'CORE_IMAGE' && !data.image) {
        data.image = extractImageUrl(block.innerHtml) || ''
      } else if (block.type === 'CORE_HEADING' && !data.title) {
        data.title = getInnerText(block.innerHtml || '')
      } else if (block.type === 'CORE_PARAGRAPH' && !data.description) {
        data.description = getInnerText(block.innerHtml || '')
      }

      if (block.innerBlocks?.length && (!data.image || !data.title || !data.description)) {
        for (const innerBlock of block.innerBlocks) {
          this.traverse(innerBlock, data)
        }
      }
    }
  }
})
</script>
